import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared';
import { useTranslation } from 'react-i18next';

export function UpdateTermineSubmitButton({ form }: UpdateTermineFormProps) {
  const { t } = useTranslation();

  return (
    <form.AppForm>
      <div className="block md:hidden">
        <form.SubmitButton
          buttonText={t('domain.termine.form.fertig')}
          variant="ghost-primary"
          size="sm"
        />
      </div>
      <div className="hidden md:block">
        <form.SubmitButton
          buttonText={t('domain.termine.form.fertig')}></form.SubmitButton>
      </div>
    </form.AppForm>
  );
}
